// import Vue from 'vue'
import { HTTP } from '../utils'

export default (to, from, next) => {
  const token = HTTP.defaults.headers.common['Authorization']
  // console.log('to: ' + to.path + '; from: ' + from.path + '; token; ' + token)

  if (token === null || token === undefined || !token || !token.length) {
    // console.log('redirect to login ...')
    next('/signin')
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js